<template>
	<div class = "footer">
		<div class="modal fade" id="progressDialog" tabindex="-1" role="dialog">
		    <div class="modal-dialog">
		        <div class="modal-content">
		            <div class="modal-header">
		                <h1>正在进行中...</h1>
		            </div>
		            <div class="modal-body">
		                <div class="progress">
		                    <div class="progress progress-striped active">
		                        <div class="progress-bar progress-bar-success" style="width: 100%;"></div>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
		
		<!-- 模态框（Modal） -->
		<div class="modal fade" id="urlModal" tabindex="-1" role="dialog" aria-labelledby="urlModalLabel" aria-hidden="true">
		    <div class="modal-dialog">
		        <div class="modal-content">
		            <div class="modal-header">
		                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
		                <h4 class="modal-title" id="myModalLabel">URL地址</h4>
		            </div>
		            <div class="modal-body">
		                <div class="form-group  ">
		                    <label for=" " class="col-sm-2 control-label">URL地址:</label>
		                    <div class="col-sm-8 input-group">
		                        <div class="input-group col-sm-12 date startAt" style="float:left;">
		                            <input class="form-control urlmodal_input" type="text">
		                        </div>
		                    </div>
		                </div>
		            </div>
		            <div class="modal-footer">
		                <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
		                <button type="button" class="btn btn-primary modal_submit">确定</button>
		            </div>
		        </div><!-- /.modal-content -->
		    </div><!-- /.modal -->
		</div>
	</div>
</template>

<script>
	import sideBar from "@/components/comHtml/sideBar"
	export default {
		name: 'test',
		data() {
			return {
			}
		},
		components: {
			sideBar
		},
		created: function() {
		},
		mounted: function() {
		},
		methods: {
		}

	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comHtml/comFooter.vue